import React, {useEffect, useState} from "react";
import {getArrayByNumber} from "../../utils/arrayUtils";
import IconBtn from "../icon/IconBtn";
import colorUtils from "../../colorUtils";
import {FormSingleElementArray} from "./FormSingleElementArray";
import Label from "./label/Label";
import {ColFormModel} from "./models/FormModule";


export const FormElementsArray = ({
                                      structure,
                                      dataForm = {},
                                      isSubmit,
                                      initArrayLength = 1,
                                      changeValue,
                                      setData,
                                      dataFormatted = {},
                                      pre = '',
                                      rightTemplate,
                                      titleTemplate,
                                      style,
                                      errors,
                                      addLabel,
                                  }: {
    structure: any;
    initArrayLength?: number
    dataForm?: any;
    dataFormatted: any
    isSubmit?: boolean;
    changeValue?: any;
    setData?: any;
    rightTemplate?: any;
    titleTemplate?: any;
    style?: any;
    pre?: string
    errors?: any
    addLabel?: string
}) => {
    const [number, setNumber] = useState(initArrayLength)
    useEffect(() => {
        setNumber(initArrayLength)
    }, [initArrayLength]);

    useEffect(() => {
        dataFormatted.length > number && setNumber(dataFormatted.length)
    }, [dataForm]);
    const addElementHandler = () => {
        if (dataFormatted.length >= number) {
            setNumber(number + 1)
        }
    }

    const removeItemHandler = (index: number) => {
        setNumber(number - 1)
        setData && setData(dataFormatted.filter((ele: any, i: number) => index !== i), pre)
    }
    const colSize = (structure: any) => structure?.col ? (Object.keys(structure?.col) as Array<keyof ColFormModel>).map((ele) => `col-${ele}-${structure.col[ele]}`).join(' ') : ''

    return (
        <div className={'container-fluid'}>
            <div className={'form-array row gap-2 align-items-center'}>
                {/*<div className="row">
                    <div className="col w-100">
                        <div className="row">
                            {structure.map((ele: any, k: number) =>
                                <div className={`${colSize(ele)}`} key={k}>
                                    {ele?.label ? (
                                        <div className={''}>
                                            <Label {...ele} />
                                        </div>
                                    ) : null}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className={'col-auto'}></div>
                </div>*/}
                <div className={"col-12 d-flex flex-column gap-2"}>
                    <div className={'d-flex justify-content-end align-items-center gap-2 mt-2'}>
                        <span className={'text-primary'}>{addLabel ? addLabel : 'Add'}</span>
                        <IconBtn variant={'outline'} icon={'/assets/icons/plus-c.svg'} size={'20px'}
                                 disabled={dataForm.length < number}
                                 clickHandler={addElementHandler} tintColor={colorUtils.theme.primary}></IconBtn>
                    </div>
                    {getArrayByNumber(number).map((num, k) => <FormSingleElementArray
                        key={k}
                        errors={errors}
                        structure={structure}
                        pre={pre}
                        num={num}
                        isSubmit={isSubmit}
                        removeItemHandler={removeItemHandler}
                        changeValueHandler={changeValue}
                        dataForm={dataForm}
                        titleTemplate={titleTemplate}
                    />)}
                </div>
            </div>
        </div>
    );
};
